/**
 * Modern Propane — collection store interactions
 * Sticky filter toggle (mobile), category nav scroll hints.
 */
(function () {
  'use strict';

  function initCollectionStore() {
    var root = document.querySelector('[data-section-type="mp-collection-store"]');
    if (!root) return;

    var filterToggle = root.querySelector('[data-mp-col-filter-toggle]');
    var filtersPanel = root.querySelector('[data-mp-col-filters]');

    if (filterToggle && filtersPanel) {
      filterToggle.addEventListener('click', function () {
        var expanded = filterToggle.getAttribute('aria-expanded') === 'true';
        filterToggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        if (expanded) {
          filtersPanel.setAttribute('hidden', '');
        } else {
          filtersPanel.removeAttribute('hidden');
        }
      });
    }

    var navTrack = root.querySelector('[data-mp-col-nav-track]');
    if (navTrack) {
      var active = navTrack.querySelector('.is-active');
      if (active && typeof active.scrollIntoView === 'function') {
        active.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionStore);
  } else {
    initCollectionStore();
  }

  document.addEventListener('shopify:section:load', function (evt) {
    if (evt.detail && evt.detail.sectionId) {
      var section = document.querySelector('[data-section-id="' + evt.detail.sectionId + '"]');
      if (section && section.getAttribute('data-section-type') === 'mp-collection-store') {
        initCollectionStore();
      }
    }
  });
})();
